import { computed, Directive, input } from '@angular/core';

import { NodeType } from '@reach/interfaces/nodes/node-type.enum';

export const NODE_TYPE_ICON_MAP: Record<NodeType, string> = {
	[NodeType.TAG]: 'icon-tag',
	[NodeType.FILE]: 'icon-document',
	[NodeType.WEBSITE]: 'icon-website',
	[NodeType.NOTE]: 'icon-note',
};

export const NODE_TYPE_COLOR_MAP: Record<NodeType, string> = {
	[NodeType.TAG]: 'node-tag',
	[NodeType.FILE]: 'node-document',
	[NodeType.WEBSITE]: 'node-website',
	[NodeType.NOTE]: 'node-note',
};

@Directive({
	selector: '[nodeTypeIcon]',
	standalone: true,
	host: {
		'[class]': '$class()',
	},
})
export class NodeTypeIconDirective {
	public readonly $nodeType = input<NodeType | null>(null, { alias: 'nodeTypeIcon' });
	public readonly $colored = input(true, { alias: 'colored' });

	public readonly $class = computed(() => {
		const type = this.$nodeType();
		const colored = this.$colored();

		if (!type) {
			return '';
		}

		const valid = Object.values(NodeType).includes(type);

		if (!valid) {
			return '';
		}

		const icon = NODE_TYPE_ICON_MAP[type];
		const color = colored ? `${NODE_TYPE_COLOR_MAP[type] || ''} text-node-type` : '';

		return `${icon} ${color}`.trim();
	});
}
